import axios from "axios";
import globalValues from "../../globalValues";
import { generateToken } from "../../token/requests/Token";

export const getAllTableMerging = async () => {
  try {
    const locationID = localStorage.getItem("wrlId");
    if (locationID !== "") {
      const token = await generateToken();
      if (token) {
        return new Promise(async (resolve, reject) => {
          let headers = {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          };
          let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/table-merge/location/${locationID}/findall`;
          await axios({
            method: "GET",
            url: url,
            headers,
          })
            .then((response) => {
              if (response.data.Result !== null) {
                resolve(response.data.Result);
              } else {
                resolve([]);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    }
  } catch (error) {
    console.error("Error In getAllTableMerging Data", error);
  }
};
export const deleteTableMerging = async (id: any) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/table-merge/${id}/delete`;
        await axios({
          method: "DELETE",
          url: url,
          headers,
        })
          .then((response) => {
            if (response.data.Status) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In deleteTableMerging Data", error);
  }
};
export const handleAutoMerging = async (status: boolean) => {
  try {
    const locationID = localStorage.getItem("wrlId");
    if (locationID !== "") {
      const token = await generateToken();
      if (token) {
        return new Promise(async (resolve, reject) => {
          let headers = {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          };
          let data = {
            CloudLocationID: locationID,
            Enable: status,
          };
          let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-reservations/auto-merge`;
          await axios({
            method: "PUT",
            url: url,
            headers,
            data,
          })
            .then((response) => {
              if (response.data.Status) {
                resolve(locationID);
              } else {
                resolve("");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    }
  } catch (error) {
    console.error("Error In handle Auto Merging Data", error);
  }
};
export const updateAutoMerging = async (tables: []) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let data = {
          Tables: tables,
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/table/auto-merge`;
        await axios({
          method: "PUT",
          url: url,
          headers,
          data,
        })
          .then((response) => {
            resolve(response.data.Status);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In update Auto Merging Data", error);
  }
};

export const addManualTableMerge = async (tables: any) => {
  try {
    const locationID = localStorage.getItem("wrlId");
    if (locationID !== "") {
      const token = await generateToken();
      if (token) {
        return new Promise(async (resolve, reject) => {
          let headers = {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          };
          let data = {
            TableMergeID: tables.tableMergeID,
            OrganizationID: tables.organizationID,
            CloudLocationID: locationID,
            MergedTables: tables.mergedTables,
            GroupName: tables.displayName,
            Cover: tables.cover,
          };
          let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/table-merge/add`;
          await axios({
            method: "POST",
            url: url,
            headers,
            data,
          })
            .then((response) => {
              console.log(response.data, response.data);
              resolve(response.data.Status);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    }
  } catch (error) {
    console.error("Error In handle Auto Merging Data", error);
  }
};
